<template>
    <v-form ref="mondaySettForm">
      <v-row align="center" justify="center">
        <h3><b>Monday</b></h3>
      </v-row>
      <v-row align="center" justify="center">
        <v-col :cols="7">
          <v-switch :disabled="disable || preview" @change="onChange" :label="$t('json.export_skip')" v-model="EndpointMonday.SkipExportSettings"></v-switch>
          <br/>
        </v-col>
      </v-row>
    </v-form>
</template>

<script>
export default {
  name: 'MondayEndpointSettings',
  props: {
    EndpointMonday: {
      type: Object
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      user: '',
      pass: '',
      maxChunkSize: 2,
      initedPass: false
    }
  },
  computed: {
    useAppendIcon () {
      if (this.initedPass) return undefined
      return this.EndpointMFiles.showPass ? 'mdi-eye' : 'mdi-eye-off'
    }
  },
  mounted () {
    /* const cryptoUser = atob(this.EndpointMFiles.username)
    const cryptoPass = atob(this.EndpointMFiles.password)
    this.user = cryptoUser
    this.pass = cryptoPass
    // this.maxChunkSize = this.EndpointMFiles.
    if (this.pass) this.initedPass = true
    console.log('MFILES SETTINGS', this.user, this.initedPass) */
  },
  methods: {
    /* async onChangeUser (val) {

    },
    async onChangePass (val) {
      if (!this.pass) {
        this.initedPass = false
      }
    },
    async saveUP () {
      this.EndpointMFiles.username = btoa(this.user)
      this.EndpointMFiles.password = btoa(this.pass)
      this.$emit('changeSettings')
    }, */
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
